import AppHeader from "../../layout/AppHeader";
import Team from '../../xpost/views/umov/team/Team.vue';
import TeamAdd from '../../xpost/views/umov/team/TeamAdd.vue';

const TeamRoutes = [
  {
    path: "/cadastro/equipe",
    name: "team",
    components: {
      header: AppHeader,
      default: Team,
    }
  },
  {
    path: "/cadastro/equipe/adicionar",
    name: "team.add",
    components: {
      header: AppHeader,
      default: TeamAdd,
    }
  },
  {
    path: "/cadastro/equipe/editar/:id",
    name: "team.edit",
    components: {
      header: AppHeader,
      default: TeamAdd,
    }
  },
]

export default TeamRoutes;